import { Component } from '@angular/core';

@Component({
  selector: 'app-email-subscribe-popup',
  templateUrl: './email-subscribe-popup.component.html',
  styleUrls: ['./email-subscribe-popup.component.scss']
})
export class EmailSubscribePopupComponent {
  inRecent : boolean=false;
  email: string = '';

  subscribe() {
    // alert(`Subscribed with: ${this.email}`);
  }

  closePopup() {
    this.inRecent = true
  }
}
